import React from 'react';
import { CenteredMessage } from './CenteredMessage';

export const Loading = () => {
    return <CenteredMessage>Loading...</CenteredMessage>;
};
